/**
 * queue #647 §UAT-2026-07-07-R647-4 — GitLab 직링크 제거.
 *
 * 이전(#628): `VITE_GITLAB_BASE` 가 주입되면 GitLab blob 직링크를 반환하고, 미주입 시
 * `null` 을 반환해 호출부가 경로 텍스트로 폴백했다. 이 링크는 (1) HTTPS 로 서빙되는 앱에서
 * http/사설 IP 로 이탈(혼합 콘텐츠), (2) GitLab 사내 SSO 계정이 없는 일반 사용자를
 * 로그인 벽에 막고, (3) `VITE_GITLAB_BASE` 미주입 환경에서는 문서 접근 자체가 불가했다.
 *
 * 이후(#647): `docs/consumer-guide.md` 를 앱이 빌드타임에 직접 번들해 인앱 라우트
 * (`/getting-started/consumer-guide`)로 서빙한다. 항상 사용 가능한 내부 라우트 상수를
 * 반환 — `null` 폴백·`VITE_GITLAB_BASE` 참조 모두 제거.
 */
export const CONSUMER_GUIDE_PATH = 'docs/consumer-guide.md'; // 다운로드 파일 표기·SSOT 경로(유지)
export const CONSUMER_GUIDE_ROUTE = '/getting-started/consumer-guide';

/** 항상 내부 라우트를 반환한다(널 불가) — 소비처는 react-router `Link` 로 내부 이동한다. */
export function consumerGuideUrl(): string {
  return CONSUMER_GUIDE_ROUTE;
}
